import {defineCustomElement} from 'extensions/ui-utils';
import {html, LitElement} from 'lit';
import stylesheet from './x-default-basket-container.scss?as=stylesheet';
import 'extensions/ui-components/x-quantity';

export class DefaultBasketContainer extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {};
	}

	constructor () {
		super();
	}

	render () {

		return html`
			<div class="container">
				<slot></slot>
			</div>
		`;
	}
};

defineCustomElement('x-default-basket-container', DefaultBasketContainer);
